import { Controller } from "@hotwired/stimulus"

// Small shared copy-to-clipboard affordance (marketing share links).
// Usage: data-controller="clipboard" data-clipboard-text-value="https://…"
//        with a data-clipboard-target="button" data-action="clipboard#copy".
export default class extends Controller {
  static targets = ["button"]
  static values = { text: String }

  async copy() {
    const text = this.textValue || window.location.href
    try {
      await navigator.clipboard.writeText(text)
    } catch {
      const input = document.createElement("textarea")
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand("copy")
      input.remove()
    }
    this.flash()
  }

  flash() {
    if (!this.hasButtonTarget) return
    const original = this.buttonTarget.textContent
    this.buttonTarget.textContent = "Link copied ✓"
    clearTimeout(this.resetTimer)
    this.resetTimer = setTimeout(() => (this.buttonTarget.textContent = original), 2000)
  }
}
